import userApi from '../../api/user';

const user = {
  state: {
    userInfo: null, // 存储用户基本信息
    perms: [],// 权限列表
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_PERMS(state, perms) {
      state.perms = perms;
    }
  },
  actions: {
    // 从后台获取最新用户信息
    async fetchUserInfo({ commit }) {
      const res = await userApi.getCurrentUser(); // 调用user.js中的方法获取用户信息
      if (res.success) {
        commit('SET_USER_INFO', res.data);
        commit('SET_PERMS', res.perms || []);
        return res.data;
      }
      return null;
    },
  },
};

export default user;